import { useDemo } from '../contexts/DemoContext';

// Меню-канон APL (shared/patterns/admin-menu-canon.md):
// Система → Ядро (проектное имя) → Операции → Аналитика →
// Наблюдаемость → Справка.
const MENU_GROUPS = [
  {
    id: 'system',
    label: 'Система',
    items: [
      { id: 'dashboard', label: 'Панель состояния', icon: '📊' },
      { id: 'ai-config', label: 'AI и Retrieval', icon: '⚙️' },
      { id: 'orchestrator', label: 'Оркестратор', icon: '🧭' },
    ],
  },
  {
    id: 'content',
    label: 'База знаний',
    items: [
      { id: 'kb', label: 'База знаний', icon: '📚' },
    ],
  },
  {
    id: 'analytics',
    label: 'Аналитика',
    items: [
      { id: 'analytics', label: 'Дашборд', icon: '📈' },
      { id: 'reports', label: 'Бизнес-отчёты', icon: '📉' },
    ],
  },
  {
    id: 'operations',
    label: 'Наблюдаемость',
    items: [
      { id: 'logs', label: 'Логи', icon: '📜' },
      { id: 'dialogs', label: 'Диалоги', icon: '💬' },
      { id: 'audit', label: 'Журнал аудита', icon: '📋' },
    ],
  },
  {
    id: 'reference',
    label: 'Справка',
    items: [
      { id: 'legend', label: 'Обозначения', icon: '🗺️' },
    ],
  },
];

function Sidebar({ active, onChange, onLogout, theme, onToggleTheme }) {
  const { isDemo } = useDemo();

  return (
    <aside className="ai-sidebar">
      <div className="ai-sidebar__brand">
        <span className="ai-sidebar__brand-icon">🤖</span>
        <span>AI Curator</span>
      </div>

      {isDemo && (
        <div className="mx-3 mb-3 rounded-ai border border-ai-warning/30 bg-ai-warning/10 px-3 py-2 text-xs text-ai-warning">
          🔒 Демо-режим: только просмотр
        </div>
      )}

      <nav className="ai-nav">
        {MENU_GROUPS.map((group) => (
          <div key={group.id} className="ai-nav__group">
            <p className="ai-nav__group-label">{group.label}</p>
            <div className="ai-nav__items">
              {group.items.map((item) => (
                <button
                  key={item.id}
                  onClick={() => onChange(item.id)}
                  className={`ai-nav__link ${active === item.id ? 'ai-nav__link--active' : ''}`}
                  type="button"
                >
                  <span>{item.icon}</span>
                  <span>{item.label}</span>
                </button>
              ))}
            </div>
          </div>
        ))}
      </nav>

      <div className="ai-sidebar__footer">
        <button
          onClick={onToggleTheme}
          className="ai-sidebar__logout mb-2"
          type="button"
          title="Переключить тему оформления"
        >
          <span>{theme === 'dark' ? '☀️' : '🌙'}</span>
          <span>{theme === 'dark' ? 'Светлая тема' : 'Тёмная тема'}</span>
        </button>
        <button onClick={onLogout} className="ai-sidebar__logout" type="button">
          <span>🚪</span>
          <span>Выйти</span>
        </button>
      </div>
    </aside>
  );
}

export default Sidebar;
